<!--
포장옵션을 입력하는 컴포넌트
-->
<template>
    <div class="root">
        <!-- 현재 선택된 내역표시 -->
        <div class="selected_list uk-flex uk-flex-top uk-flex-wrap uk-flex-left">
            <div
                v-for="(option, index) in items"
                :key="index"
                class="item"
            >
                <i class="material-icons check">check</i>
                {{ option.name }}
            </div>
        </div>

        <!-- 작성 -->
        <div class="button-panel uk-flex uk-flex-top">
            <div class="uk-width-expand uk-flex uk-flex-left uk-flex-wrap">
                <button
                    v-for="opt in favorites"
                    :key="opt.id"
                    class="uk-button uk-button-gray uk-button-small uk-margin-small-bottom uk-margin-small-right"
                    @click="add(opt)"
                >
                    {{ opt.name }}
                </button>
            </div>

        </div>
        <button
            class="uk-button uk-button-gray uk-button-small uk-width-1-1"
            v-on:click="openModal"
        >
            <i class="material-icons">playlist_add</i>
            (전체)포장옵션
        </button>

        <!-- modal 창 -->
        <div class="modal-packing-options uk-modal-full" uk-modal esc-close="true" bg-close="false" uk-height-viewport>

            <div class="uk-flex uk-flex-top uk-height-1-1 uk-background-default">
                <!-- 선택목록 -->
                <div class="options uk-width-2-5 uk-flex uk-flex-column uk-flex-between uk-flex-stretch uk-height-1-1">
                    <h4>
                        <i class="material-icons">playlist_add</i>
                        포장옵션을 선택하세요
                    </h4>
                    <div class="list uk-height-1-1 uk-overflow-auto">

                        <div
                            v-for="(option) in options"
                            :key="option.name"
                            class="item"
                            v-on:click="add(option)"
                        >
                            <i class="material-icons">add_circle</i>
                            {{ option.name }}
                        </div>
                    </div>
                </div>

                <!-- 결과 -->
                <div class="items uk-width-2-5 uk-flex uk-flex-column uk-flex-between uk-flex-stretch uk-height-1-1">
                    <h4>
                        <i class="material-icons">playlist_add_check</i>
                        SELECTED
                    </h4>
                    <div class="list uk-height-1-1 uk-overflow-auto">

                        <div
                            v-for="(option, index) in items"
                            :key="index"
                            class="item"
                        >
                            <i class="material-icons check">check</i>
                            {{ option.name }}
                            <i
                                class="material-icons remove uk-float-right"
                                title="click to remove"
                                v-on:click="remove(index)"
                            >
                                remove_circle
                            </i>
                        </div>
                    </div>

                </div>


                <!-- 컨트롤 패널 -->
                <div class="controll uk-width-expand">
                    <div v-show="totalWeight" class="uk-text-center uk-margin-bottom">

                        <div class="info">
                            <div class="title">
                                무게
                            </div>
                            <div class="body">
                                {{ totalWeight.weight }}
                                <span class="unit">KG</span>
                            </div>
                        </div>

                        <div class="info">
                            <div class="title">
                                부피무게
                            </div>
                            <div class="body">
                                {{ totalWeight.volume_weight }}
                                <span class="unit">KG</span>
                            </div>
                        </div>

                        <div class="info">
                            <div class="title">
                                적용무게
                            </div>
                            <div class="body highlight">
                                {{ totalWeight.apply_weight }}
                                <span class="unit">KG</span>
                            </div>
                        </div>

                    </div>
                    <div class="uk-text-center">
                        <button class="uk-button uk-button-secondary uk-button-large uk-modal-close" type="button">
                            <span uk-icon="icon: check"></span> 작성완료
                        </button>
                    </div>

                </div>

            </div>


        </div>


    </div>
</template>

<script>
export default {
    props: {
        /**
         * 지역id
         */
        regionId: {
            type: Number,
            default: null,
        },

        /**
         * 외부에서 이 컴포넌트에 접근하기위해 등록될 전역변수명
         */
        globalVnodeName: {
            type: String,
            default: 'packing_options'
        },

        /**
         * 초기 items 정보
         *
         * 예 )
         * [
         *      {name: 옵션명칭},
         *      {name: 옵션명칭},
         *      .
         *      .
         * ]
         */
        initItems: {
            type: Array,
            default: function () {
                return [];
            }
        },

        /**
         * 총 무게정보  {weight, volume_weight, apply_weight}
         */
        totalWeight: {
            type: Object,
            default: {},
        }
    },
    data: function () {
        return {
            // 설정된 포장옵션 배열
            items: _.map(this.initItems, _.clone),

            /**
             * 선택가능한 옵션목록
             * @param options [
             *      {name: 옵션명칭},
             *      {name: 옵션명칭},
             *      .
             *      .
             * ]
             */
            options: null,

            /**
             * 즐겨찾기 옵션목록
             * @param options [
             *      {name: 옵션명칭},
             * ]
             */
            favorites: null,
        };
    },
    computed: {},
    watch: {},
    mounted: function () {
        // 전역에 현재 컴포넌트 등록
        window[this.globalVnodeName] = this;

        // 현재 vnode 에 모달창 html 엘리먼트 등록해둠. (창을 반복적으로 띄울때 필요함)
        this.$modalElement = $(this.$el).find('.modal-packing-options');

        // 옵션읽어옴
        this.loadOptions();

    },
    methods: {

        /**
         * 선택옵션 ajax load
         */
        loadOptions: function () {
            // 최초 한번만 실행
            if (this.options !== null) {
                return;
            }

            let cmp = this;
            let opts = {
                type: 'get',
                url: '/regions/' + cmp.regionId + '/packing-options/only-name',

                success: function (res) {
                    //console.log(res);

                    cmp.options = []; // 초기화
                    cmp.favorites = []; // 초기화

                    _.forEach(res.options, function (opt) {
                        cmp.options.push(opt);
                        if (opt.favorite === 1) {
                            cmp.favorites.push(opt);
                        }
                    });

                }
            };

            // ajax 실행
            $.app.ajax.module.default(opts);

        },

        /**
         * modal 창 띄움.
         *  - 포장옵션 작성
         */
        openModal: function () {
            // 선택옵션 load
            this.loadOptions();

            // 창 띄움
            UIkit.modal(this.$modalElement).show();
        },
        /**
         * modal 창 닫음
         */
        closeModal: function () {
            // 창 닫음
            UIkit.modal(this.$modalElement).hide();
        },
        /**
         * 포장옵션 정보를 json 반환
         */
        getJson: function () {
            let arr = [];
            _.forEach(this.items, function (opt, key) {
                arr.push({
                    name: opt.name,
                });
            });
            return JSON.stringify(arr);
        },
        /**
         * 포장옵션 추가
         * @param init 포장옵션 정보
         */
        add: function (init) {
            this.items.push(
                $.extend({
                    name: null,
                }, init)
            );
        },
        /**
         * 복사
         * @param index 선택한 배열 index
         */
        duplicate: function (index) {
            this.items.push($.extend({}, this.items[index]));

            //this.rebindAllProd();
        },
        /**
         * 제거
         * @param index 선택한 배열 index
         */
        remove: function (index) {
            if (!confirm('정말 제거합니까?')) {
                return;
            }

            //console.log('remove is '+index);
            this.items.splice(index, 1);
            //console.log(this.items);

            //this.rebindAllProd();

        }
    }
}
</script>

<style lang="scss" scoped>
.root {

}

// 선택된 내역표시
.selected_list {
    margin-left: 15rem;

    .item {
        text-align: left;
        font-size: 1rem;
        padding: 5px;
        margin: 3px;

        border: 2px solid #1e87f0;
        background-color: #fff;
        color: #000;


        // 아이콘
        .material-icons {
            font-size: 1.5rem;
            color: #1e87f0;
        }
    }
}

// 버튼패널
.button-panel {
    background-color: #fafafa;
    padding: 10px;
    border: 1px solid #cfcfcf;
}

// 모달
.modal-packing-options {
    // 창 크기
    .uk-modal-dialog {
        //width: 80%;
    }

    // 선택옵션, 선택결과 공통
    .options, .items {
        padding: 0 5px;

        h3 {
            text-align: left;

            .material-icons {
                font-size: 1.5rem;
                vertical-align: middle;
            }

            background-color: #fff;
            padding: 5px;
            margin: 0;
            border-bottom: 1px solid #666;
        }

        .list {


            .item {
                text-align: left;
                font-size: 1rem;
                padding: 5px;
                margin-bottom: 5px;

                // 아이콘
                .material-icons {
                    font-size: 1.5rem;
                    vertical-align: middle;
                }

                // 텍스트 선택막기
                -ms-user-select: none;
                -moz-user-select: none;
                -webkit-user-select: none;
                user-select: none;
            }
        }

    }

    // 선택옵션 영역
    .options {
        .item {
            border: 1px dashed #cfcfcf;

            // 아이콘
            .material-icons {
                font-size: 1.5rem;
                color: #cfcfcf;
            }

            // 마우스오버
            cursor: pointer;

            &:hover {
                border: 1px solid #000;

                .material-icons {
                    color: #000;
                }
            }


        }
    }

    // 선택결과 영역
    .items {
        h3 {
            color: #1e87f0;
        }

        .item {
            border: 2px solid #1e87f0;

            // 아이콘
            .material-icons.check {
                color: #1e87f0;
            }

            .material-icons.remove {
                color: #f0506e;

                // 마우스오버
                cursor: pointer;
            }
        }

        border-right: 1px solid #666;
    }

    // 컨트롤 패널
    .controll {
        .info {
            margin: 5px 10px;
            border: 1px solid #ddd;

            .title {
                font-size: 1rem;
                border-bottom: 1px solid #ddd;
                background-color: #fefefe;
                padding: 5px;
            }

            .body {
                font-size: 1rem;
                color: #000;
                padding: 5px;

                &.highlight {
                    color: #1e87f0;
                }

                .unit {
                    font-size: 1rem;
                    color: #ccc;
                }
            }

        }
    }

}
</style>